import { logger } from '@tuic/logger';

import { Mps } from '../../index';
import { errorContains } from '../../utils/error';

import type { TriggerPreferenceMailRequest } from '../../generated/mps';

export enum TRIGGER_LOST_AND_FOUND_EMAIL_RESPONSE {
  SUCCESS,
  GENERAL_ERROR,
  RECIPIENT_DOES_NOT_EXIST,
}

export async function triggerLostAndFoundEmail(
  data: TriggerPreferenceMailRequest,
): Promise<TRIGGER_LOST_AND_FOUND_EMAIL_RESPONSE> {
  const { error } = await Mps.triggerTransactionMail({
    body: data,
  });

  if (!error) {
    logger.info('[MPS] Successfully triggered lost and found email', {
      email: data.email,
      type: data.type,
    });
    return TRIGGER_LOST_AND_FOUND_EMAIL_RESPONSE.SUCCESS;
  }

  if (errorContains(error, 'recipient not found')) {
    logger.warn('[MPS] Recipient not found for lost and found email', {
      email: data.email,
    });
    return TRIGGER_LOST_AND_FOUND_EMAIL_RESPONSE.RECIPIENT_DOES_NOT_EXIST;
  }

  logger.error('[MPS] Failed triggering lost and found email');
  logger.error(error);

  return TRIGGER_LOST_AND_FOUND_EMAIL_RESPONSE.GENERAL_ERROR;
}
